import type { CSSProperties, FC, ReactNode } from "react";

interface ContentCardProps {
  children: ReactNode;
  className?: string;
  padding?: "none" | "sm" | "md" | "lg";
  style?: CSSProperties;
}

/**
 * Embedded surface card for section content — hard-edge border, subtle shadow,
 * light/dark background. Use FloatingCard for overlay / tooltip contexts.
 */
export const ContentCard: FC<ContentCardProps> = ({
  children,
  className = "",
  padding = "md",
  style,
}) => {
  const paddingClasses = { lg: "p-4", md: "p-3", none: "", sm: "p-2" };

  return (
    <div
      className={`rounded-none border border-slate-300 bg-white shadow-sm dark:border-2 dark:border-slate-700 dark:bg-arti-panel ${paddingClasses[padding]} ${className}`
        .trim()
        .replace(/\s+/g, " ")}
      style={style}
    >
      {children}
    </div>
  );
};
